(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ybaa-donation"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-ybaa-donation]').forEach((donation) => {
      const tabs = donation.querySelectorAll('[data-donation-tab]');
      const panels = donation.querySelectorAll('[data-donation-panel]');

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const selected = tab.dataset.donationTab;

          tabs.forEach((item) => {
            const active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', String(active));
          });

          panels.forEach((panel) => {
            panel.hidden = panel.dataset.donationPanel !== selected;
          });
        });
      });

      donation.querySelectorAll('[data-donation-amount]').forEach((amount) => {
        amount.addEventListener('click', () => {
          amount.parentElement.querySelectorAll('[data-donation-amount]').forEach((item) => {
            const active = item === amount;
            item.classList.toggle('is-selected', active);
            item.setAttribute('aria-pressed', String(active));
          });
        });
      });

      donation.querySelectorAll('[data-donation-checkout]').forEach((checkout) => {
        checkout.addEventListener('click', async () => {
          const gift = checkout.closest('[data-donation-gift]');
          const error = gift.querySelector('[data-donation-error]');
          const customAmount = gift.querySelector('[data-donation-custom-amount]');
          const body = new URLSearchParams();

          error.hidden = true;

          if (customAmount) {
            const amount = Number(customAmount.value);

            if (!Number.isInteger(amount) || amount < 1 || amount > 25000) {
              error.textContent = 'Enter a whole dollar amount between $1 and $25,000.';
              error.hidden = false;
              customAmount.focus();
              return;
            }

            body.set('id', gift.dataset.variantId);
            body.set('quantity', String(amount));
          } else {
            const selected = gift.querySelector('[data-donation-amount].is-selected');

            if (!selected) return;

            body.set('id', selected.dataset.variantId);
            body.set('quantity', '1');
          }

          if (gift.dataset.sellingPlan) {
            body.set('selling_plan', gift.dataset.sellingPlan);
          }

          checkout.disabled = true;

          try {
            const affiliation = donation.querySelector('[data-donation-affiliation]');
            const year = donation.querySelector('[data-donation-year]');
            const attributes = new URLSearchParams();
            attributes.set('attributes[Affiliation]', affiliation ? affiliation.value.trim() : '');
            attributes.set('attributes[Class year]', year ? year.value.trim() : '');

            const attributeResponse = await fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              body: attributes,
            });

            if (!attributeResponse.ok) throw new Error('Unable to save affiliation');

            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              body,
            });

            if (!response.ok) throw new Error('Unable to add donation');

            window.location.href = window.Shopify.routes.root + 'checkout';
          } catch (requestError) {
            error.textContent = 'We could not start your checkout. Please try again.';
            error.hidden = false;
            checkout.disabled = false;
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
